/**
 * Order sale action semantics for the sales order workflow.
 *
 * Keeps the grid, detail drawer, and full order form aligned on the
 * status-aware labels and the confirmation policy for destructive actions.
 */

const TERMINAL_STATUSES = new Set(['Complete', 'Cancelled', 'Deleted']);
const PROCESSED_CANCEL_STATUSES = new Set(['Billing - On Hold', 'Shipped', 'Complete']);
const CONFIRMED_CANCEL_STATUSES = new Set(['Draft', 'New', ...PROCESSED_CANCEL_STATUSES]);

const PRIMARY_ACTIONS = {
  Draft: { label: 'Edit Draft', i18nKey: 'warehouse.editDraft' },
  New: { label: 'Process', i18nKey: 'warehouse.processOrder' },
  'Billing - On Hold': { label: 'Review Hold', i18nKey: 'warehouse.reviewBillingHold' },
  Shipped: { label: 'Bill', i18nKey: 'warehouse.billOrder' },
};

export const getOrderSalePrimaryAction = status => {
  if (PRIMARY_ACTIONS[status]) return PRIMARY_ACTIONS[status];
  if (TERMINAL_STATUSES.has(status)) {
    return { label: 'View', i18nKey: 'warehouse.viewOrder' };
  }
  return { label: 'Edit', i18nKey: 'warehouse.editOrder' };
};

export const isOrderSaleCancellationConfirmed = status => CONFIRMED_CANCEL_STATUSES.has(status);

const isOrderSaleProcessedCancellation = status => PROCESSED_CANCEL_STATUSES.has(status);

export const getOrderSaleCancelDialog = status => {
  const isProcessed = isOrderSaleProcessedCancellation(status);
  return {
    isProcessed,
    title: isProcessed ? 'Cancel Processed Order?' : 'Cancel Order?',
    titleI18nKey: isProcessed ? 'warehouse.cancelProcessedOrderTitle' : 'warehouse.cancelOrderTitle',
    bodyI18nKey: isProcessed ? 'warehouse.cancelProcessedOrderBody' : 'warehouse.cancelOrderBody',
  };
};
